import React from 'react';

import LockIcon from '@mui/icons-material/Lock';
import ShieldIcon from '@mui/icons-material/SecurityRounded';
import ThumbUpIcon from '@mui/icons-material/ThumbUpRounded';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  icon: {
    color: theme.palette.icon.light,
    fontSize: 20,
    marginRight: theme.spacing(2),
    marginTop: 3, // Align the icons with the text
  },
}));

const SecurityPrivacyTrust = () => {
  const { classes } = useStyles();

  return (
    <Box pl={1} pr={3} width={275} minWidth={275}>
      <Box display='flex'>
        <LockIcon className={classes.icon} fontSize='inherit' />
        <div>
          <Typography variant='bodyRegular'>Security</Typography>
          <Typography variant='paragraphRegular' color='textSecondary'>
            Your information is encrypted end-to-end.
          </Typography>
        </div>
      </Box>
      <Box display='flex' mt={2}>
        <ShieldIcon className={classes.icon} fontSize='inherit' />
        <div>
          <Typography variant='bodyRegular'>Privacy</Typography>
          <Typography variant='paragraphRegular' color='textSecondary'>
            Control which accounts you give access to.
          </Typography>
        </div>
      </Box>
      <Box display='flex' mt={2}>
        <ThumbUpIcon className={classes.icon} fontSize='inherit' />
        <div>
          <Typography variant='bodyRegular'>Trust</Typography>
          <Typography variant='paragraphRegular' color='textSecondary'>
            From the makers of Quicken, trusted for over 30 years.
          </Typography>
        </div>
      </Box>
    </Box>
  );
};
export default React.memo(SecurityPrivacyTrust);
